<template>
  <router-link :to="link">
    <div
      class="flex py-3 text-gray-400 hover:bg-gray-700 hover:-mx-6 transition-all duration-100"
      :class="{'hover:px-6':expanded}"
    >
      <div :class="{'w-full text-center': !expanded}">
        <icon :name="icon" size="1.5em" :settings="{strokeWidth: 1.2}" />
      </div>
      <div
        class="ml-4 self-center tracking-widest font-light uppercase text-sm truncate"
        v-if="expanded"
      >
        <slot />
      </div>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "SidebarElement",
  data() {
    return {};
  },
  props: {
    icon: {
      type: String,
      default: "Info",
      required: true
    },
    link: {
      type: String,
      required: true
    },
    expanded: {
      default: true,
      type: Boolean
    }
  },
  components: {},
  methods: {},
  computed: {},
  created() {}
};
</script>

<style scoped>
.router-link-active > div {
  @apply bg-primary-500 text-gray-900 -mx-6 px-6 transition-spacing duration-200;
}
</style>